import { Component, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { BaseAsset } from 'src/app/models/assets/BaseAsset';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { QuestionSetAsset } from 'src/app/models/assets/QuestionSetAsset';
import { Scene } from 'src/app/models/Scene';
import { AssetTypeService } from 'src/app/services/asset-type.service';

@Component({
  selector: 'app-asset-wizard-modal',
  templateUrl: './asset-wizard-modal.page.html',
  styleUrls: ['./asset-wizard-modal.page.scss'],
})
export class AssetWizardModalPage implements OnInit {
  
  public assetType: string;
  public assetInScene: AssetInScene;
  public existingAssetsInScene: AssetInScene[] = [];
  public existingScenes: Scene[] = [];
  public editing: boolean = false;

  constructor(
    public assetTypeService: AssetTypeService,    
  ) { }

  ngOnInit() {
    this.assetType = this.assetTypeService.getType(this.assetInScene.baseAsset.assetTypeId);
  }

}
